import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import Artboard from 'components/Artboard';
import { AppRoute } from 'const';
import ArtboardPreview from 'containers/ArtboardPreview';
import {
  artboardImagesLoaded as artboardImagesLoadedAction,
  artboardMounted as artboardMountedAction,
  artboardWillBeMounted as artboardWillBeMountedAction,
} from 'containers/Artboards/actions';
import { artboardContainerSelector } from './selectors';
import { useArtboardDropTarget } from './useArtboardDropTarget';

type PreviewRouteParams = {
  projectId: string;
  screenId: string;
};

const ArtboardContainer: React.FunctionComponent = () => {
  const dispatch = useDispatch();
  const { connectDropTarget, isOver } = useArtboardDropTarget();
  const baseMatch = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  const previewPath = baseMatch ? `${baseMatch.path}/${AppRoute.PREVIEW}/:screenId` : '/__no_match__';
  const previewMatch = useRouteMatch<PreviewRouteParams>(previewPath);
  const artboardImagesLoaded = useCallback(() => {
    return dispatch(artboardImagesLoadedAction());
  }, [dispatch]);

  const artboardMounted = useCallback(() => {
    return dispatch(artboardMountedAction());
  }, [dispatch]);

  const artboardWillBeMounted = useCallback(() => {
    return dispatch(artboardWillBeMountedAction());
  }, [dispatch]);

  const actions = useMemo(() => ({
    artboardImagesLoaded,
    artboardMounted,
    artboardWillBeMounted,
  }), [artboardImagesLoaded, artboardMounted, artboardWillBeMounted]);

  const selectorProps = useSelector(artboardContainerSelector);

  const props = useMemo(() => ({
    connectDropTarget,
    isOver,
    ...selectorProps,
    ...actions,
  }) as const, [connectDropTarget, isOver, selectorProps, actions]);
  const previewRouteProps = previewMatch ? { history, location, match: previewMatch } : null;

  return (
    <>
      {previewRouteProps && <ArtboardPreview {...previewRouteProps} />}
      <Artboard {...props} />
    </>
  );
};

export default ArtboardContainer;
